import React from "react";
import { About, Hero, ImgSection1, ImgSection2, PC, VM } from "../Contents";
import { HeroNavbar } from "../Components";
import { Link } from "react-router-dom";
import styled from "styled-components";

const DeleteCta = styled.section`
  width: min(1120px, calc(100% - 32px));
  margin: 24px auto 0;
  border-radius: 28px;
  background: white;
  color: #000000;
  border: 1px solid var(--gray);
  padding: 28px;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
`;

const DeleteTitle = styled.h2`
  font-size: 36px;
  font-weight: 500;
`;

const DeleteText = styled.p`
  margin: 0;
  max-width: 760px;
  line-height: 1.7;
  color: rgba(0, 0, 0);
  text-align: center;
`;

const DeleteButton = styled(Link)`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  padding: 0 20px;
  border-radius: 16px;
  background: #ea3249;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
`;

const Home = () => {
  return (
    <>
      <HeroNavbar />
      <Hero />
      <About />
      <ImgSection1 />
      <VM />
      <ImgSection2 />
      <PC />
      <DeleteCta>
        <DeleteTitle>Need to delete your TalentExplore account?</DeleteTitle>
        <DeleteText>
          Open the secure account deletion flow to log in and confirm permanent
          deletion of your account and associated data.
        </DeleteText>
        <DeleteButton to="/delete-account">Delete Account</DeleteButton>
      </DeleteCta>
    </>
  );
};

export default Home;
